
<template>
    <div class="line">
        <div class="lineEcharts" ref="singleLine_statistics"></div>
    </div>
</template>

<script>
  import EChart from 'echarts'

  export default {
    props: {
      monthData: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        singleLine_statistics: {
          option: {},
          chart: null,
          element: {},
        },
        month_data: {},
        chartArray: ['singleLine_statistics'],
      }
    },
    mounted () {
      // this.$nextTick(() => {
      //     this.initData();
      // })
      //  this.$nextTick(()=>{
      //     this.onWindowResize();
      //     window.addEventListener('resize',this.onWindowResize);
      //  })
    },
    destory () {
      window.onresize = null
    },
    beforeDestroy () {
      // this.singleLine_statistics.chart.clear();
      window.removeEventListener('resize', this.onWindowResize)
    },
    watch: {
      monthData: {
        handler: function (newVal, oldVal) {
          if (newVal !== oldVal) {
            setTimeout(() => {
              this.pageInit()
            }, 1000)
          }
        },
        deep: true
      }
    },
    methods: {
      //根据页面调整
      onWindowResize () {
        // let pageHeight = document.documentElement.clientHeight; //页面总高度
        // let lineStyle = document.querySelectorAll(".alarm")[0].clientHeight;
        let lineStyle = null
        if (document.querySelectorAll('.left_wrap') && document.querySelectorAll('.left_wrap')[0]) lineStyle = document.querySelectorAll('.left_wrap')[0].clientHeight
        if (document.querySelectorAll('.lineEcharts') && document.querySelectorAll('.lineEcharts')[0]) {
          document.querySelectorAll('.lineEcharts')[0].style.height = eval(lineStyle - 50) + 'px'  //在这里可以根据你的边距做调整
          let chartBox = this.singleLine_statistics.chart
          var width = chartBox.clientWidth
          let option = chartBox.getOption()
          if (width) {
            chartBox.resize()
            chartBox.setOption(option, true)
          }
          if (JSON.stringify(this.monthData) !== '{}') this.disposeAllChart()
        }
      },
      pageInit () {
        this.month_data = this.$deepClone(this.monthData)
        this.initData()
      },
      initData () {
        //  var x_data=[ "11月", "12月","1月","2月","3月","4月",];
        // var series_data =[3, 1,16, 8, 5, 20];
        var x_data = this.month_data.x_data.map(function (str) {
          if (str && str.length >= 7) {
            return str.substring(2, 7)
          }
        })
        var series_data = this.month_data.series_data;
        this.singleLine_statistics.option = {
          // backgroundColor: '#0f375f',
          grid: {
            top: '25%',
            bottom: '10%',
            left: '15%',  //小
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              // label: {
              //     show: true
              // }
            },
            backgroundColor: 'rgba(0,0,0,0.7)', // 背景
            padding: [8, 10], //内边距
            extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
          },
          xAxis: {
            data: x_data,
            axisLine: {
              show: true, //隐藏X轴轴线
              lineStyle: {
                color: '#193855',
              }
            },
            boundaryGap: false, //是否从零刻度开始
            axisTick: {
              show: false //隐藏X轴刻度
            },
            axisLabel: {
              // rotate: 30,
              show: true,
              interval: 0,
              textStyle: {
                color: '#08a6ad', //X轴文字颜色
                fontSize: 12,
              },

            }
          },
          yAxis: [{
            type: 'value',
            name: '（件）',
            nameTextStyle: {
              color: '#63c6e6',
              fontSize: 14
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1b4865',
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#65c6e7',
                // fontSize: 14,  //大
                fontSize: 12
              }
            }
          },
            {
              type: 'value',
              // gridIndex: 0,
              min: 50,
              max: 100,
              splitNumber: 8,
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              // splitArea: {
              //     show: true,
              //     areaStyle: {
              //         color: ["rgba(250,250,250,0.0)", "rgba(250,250,250,0.05)"]
              //     }
              // }
            }
          ],
          series: [
            {
              name: '统计',
              type: 'line',
              barWidth: 15,
              symbol: 'none', //去掉圆点
              smooth: true,  //让曲线平滑
              areaStyle: { //区域填充样式
                normal: {
                  //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                  color: new EChart.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: 'rgba(7,104,181, 0)'},
                    {offset: 0.7, color: 'rgba(16,154,174, 1)'}
                  ], false),

                  shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                  shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                }
              },
              lineStyle: {
                normal: {
                  color: '#3deaff',   // 线条颜色
                  opacity: 0.05  // 线条颜色
                }
              },
              itemStyle: {
                normal: {
                  color: new EChart.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0.6,
                    color: '#0ef7ff'
                  },
                    {
                      offset: 1,
                      color: '#00a2ff'
                    }
                  ])
                }
              },
              data: series_data
            }
          ]
        }
        // if(this.singleLine_statistics.chart!=null&&this.singleLine_statistics.chart!=''&&this.singleLine_statistics.chart!=undefined){
        //   this.singleLine_statistics.chart.dispose();
        // }
        this.singleLine_statistics.chart = EChart.init(this.$refs.singleLine_statistics)
        // this.singleLine_statistics.chart.resize();
        this.singleLine_statistics.chart.setOption(this.singleLine_statistics.option);
        var myChart = this.singleLine_statistics.chart;
        var _this = this;
        myChart.getZr().on('click', function (params) {
          var pointInPixel = [params.offsetX, params.offsetY]

          if (myChart.containPixel('grid', pointInPixel)) {
            /*此处添加具体执行代码*/

            var pointInGrid = myChart.convertFromPixel({seriesIndex: 0}, pointInPixel)
            //X轴序号
            var xIndex = pointInGrid[0]

            //获取当前图表的option
            var op = myChart.getOption()
            //获得图表中我们想要的数据
            var month = op.xAxis[0].data[xIndex]
            _this.$emit('lineDetail', month)
          }
        })

        //将可以响应点击事件的范围内，鼠标样式设为pointer--------------------
        myChart.getZr().on('mousemove', function (params) {
          var pointInPixel = [params.offsetX, params.offsetY]
          if (myChart.containPixel('grid', pointInPixel)) {
            myChart.getZr().setCursorStyle('pointer')
          }

        })
        myChart.on('mouseout', function (params) {
          var pointInPixel = [params.offsetX, params.offsetY]
          if (!myChart.containPixel('grid', pointInPixel)) {
            myChart.getZr().setCursorStyle('default')
          }

        })
        window.addEventListener('resize', this.onWindowResize)

      },
      //释放图表，销毁对象
      disposeAllChart () {
        let i = 0, len = this.chartArray.length
        for (; i < len; i++) {
          let a = this.chartArray[i]
          if (this[a].chart) {
            this[a].chart.dispose()
          }
        }
        this.initData()
      }
    }
  }
</script>
<style lang="less" scoped>
    .line {
        width: 100%;
        height: 100%;

        .lineEcharts {
            width: 100%;
            height: calc(~'100% - ' 50px);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/chart/single_line.vue